import { render, staticRenderFns } from "./subordinate_store.vue?vue&type=template&id=a3a9e824&scoped=true&"
import script from "./subordinate_store.vue?vue&type=script&lang=js&"
export * from "./subordinate_store.vue?vue&type=script&lang=js&"
import style0 from "./subordinate_store.vue?vue&type=style&index=0&id=a3a9e824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a9e824",
  null
  
)

export default component.exports